import React, { useEffect, useState } from 'react';
import './App.css';
import Footer from './Footer';

const Gallery2 = () => {
  const [activeForm, setActiveForm] = useState('Special Events');
  const [showModal, setShowModal] = useState(false);
  const [modalImages, setModalImages] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  const galleryImages = {
    'Special Events': [
      './images/Photo/Opera3.jpg',
            './images/Photo/Opera4.jpg',
            './images/Photo/Opera5.jpg',
            './images/Photo/Opera6.jpg',

    ],
    'Sri Lankan Tour': [
      './images/Photo/ST1.jpeg',
            './images/Photo/ST2.jpeg',
            './images/Photo/ST3.jpeg',
            './images/Photo/ST5.jpeg',
            './images/Photo/ST7.jpeg',
             './images/Photo/ST8.jpeg',
                        './images/Photo/ST6.jpeg',
                        './images/Photo/ST4.jpeg',
                        './images/cook.jpeg',
                        '/images/nai1.jpg',
                              '/images/nai2.jpg',
    ],
    'China Tour': [

      './images/welcome.jpeg',
    ],
  };

  const openModal = (images, index) => {
    setModalImages(images);
    setCurrentIndex(index);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setModalImages([]);
    setCurrentIndex(0);
  };

  const nextImage = () => {
    setCurrentIndex((prev) => (prev + 1) % modalImages.length);
  };

  const prevImage = () => {
    setCurrentIndex((prev) => (prev - 1 + modalImages.length) % modalImages.length);
  };

  return (
    <div>
      <div className="full-gallery-heading1">
        <h1>Discover Our Travel Gallery</h1>
        <p>
          Explore our gallery and relive unforgettable journeys through the eyes of our travelers — moments of joy, discovery, and adventure from across the world.
        </p>
      </div>

      <div className="full-gallery-container">
        <div className="galleries-container">
          <div className="galleries-button-group">
            {Object.keys(galleryImages).map((category) => (
              <button
                key={category}
                onClick={() => setActiveForm(category)}
                className={`galleries-form-toggle-button ${activeForm === category ? 'active' : ''}`}
              >
                {category}
              </button>
            ))}
          </div>

          <div className="galleries-images">
            {galleryImages[activeForm]?.length > 0 ? (
              <ul className="image-grid">
                {galleryImages[activeForm].map((imageSrc, index) => (
                  <li key={index} className="galleries-image-item">
                    <img
                      src={imageSrc}

                      className="galleries-image"
                      onClick={() => openModal(galleryImages[activeForm], index)}
                    />
                  </li>
                ))}
              </ul>
            ) : (
              <p>No images available for {activeForm}</p>
            )}
          </div>
        </div>
      </div>

      {/* Modal with Carousel */}
      {showModal && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={closeModal}>×</button>
            <div className="carousel-container2">
              <button onClick={prevImage} className="carousel-arrow left">{'<'}</button>
              <img
                src={modalImages[currentIndex]}

                className="modal-image"
              />
              <button onClick={nextImage} className="carousel-arrow right">{'>'}</button>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default Gallery2;
